
    <span
      class="badge badge-pill"
      [innerText]="content | translate"
      [class.text-white]="variant | filled"
      [class.badge-primary]="variant === 'primary'"
      [class.badge-success]="variant === 'success'"
      [class.badge-warning]="variant === 'warning'"
      [class.badge-danger]="variant === 'error'"
      [class.badge-info]="variant === 'info'"
      [class.badge-secondary]="variant === 'default'"
      [class.fieldmagic-pill-action]="purpose === 'action'"
      [style.background]="(color | filled) ? color : null"
      [style.color]="(color | filled) ? (color | bg_text_color) : null"
      [matTooltip]="tooltip | translate"
    >
    </span>
  